import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { useDispatch } from 'react-redux';
import Logo from '../../Logo';
import { useNavigate } from 'react-router-dom';
function RegisterUser() {
  let navigate = useNavigate();

  // const { orgUser } = useSelector(state => state.register);
  // const { isOrgRegister } = useSelector(state => state.storeRegister);
  // const dispatch = useDispatch();

  // const [step, setStep] = useState(0);
  // const [loader, setLoader] = useState(false);
  // const [openTerms, setOpenTerms] = useState(false);

  // const changeStep = (value) => {
  //   setStep(value);
  // };
  // const goPrevious = () => {
  //   const goBack = step - 1;
  //   setStep(goBack);
  // };

  // if (isOrgRegister === false) {
  //   return <Navigate to="/registration" />;
  // }

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState(false);

  const registerUser = async (e) => {
    e.preventDefault();
    if (!(firstName && lastName && email && password && phoneNumber)) {
      setError(true);
      return;
    }
    //dispatch action to register user
    const registeredUsers = JSON.parse(localStorage.getItem('users')) || [];

    registeredUsers.push({ firstName, lastName, email, password, phoneNumber });
    localStorage.setItem('users', JSON.stringify(registeredUsers));
    navigate('/');
  };

  return (
    <div className='register-user p-4'>
      <div className='row'>
        <div className='container'>
          <div className='pb-3 d-flex justify-content-center align-items-center flex-column'>
            <div className='p-2'>
              <Logo width='100' />
            </div>
          </div>
          <div className='pt-3 row justify-content-center align-items-center'>
            <div className='col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5'>
              {/* {
                step === 0 ?
                  <FirstStep onGoNext={changeStep} onOpenTerms={() => setOpenTerms(true)} /> :
                  <Avatar showLoader={loader} onPrevious={goPrevious} onSubmit={registerUser} />
              } */}
              <Form>
                <Form.Group controlId='firstName' className='mb-3'>
                  <Form.Control
                    type='text'
                    size='lg'
                    className='input-rounded border'
                    placeholder='First Name'
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                  {error && !firstName && (
                    <Form.Text className='small help-block text-danger'>
                      FirstName is required
                    </Form.Text>
                  )}
                </Form.Group>

                <Form.Group controlId='lastName' className='mb-3'>
                  <Form.Control
                    type='text'
                    size='lg'
                    className='input-rounded border'
                    placeholder='Last Name'
                    onChange={(e) => setLastName(e.target.value)}
                  />
                  {error && !lastName && (
                    <Form.Text className='small help-block text-danger'>
                      LastName is required
                    </Form.Text>
                  )}
                </Form.Group>

                <Form.Group controlId='email' className='mb-3'>
                  <Form.Control
                    type='email'
                    size='lg'
                    className='input-rounded border'
                    placeholder='E-mail Address'
                    pattern='/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/'
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {error && !email && (
                    <Form.Text className='small help-block text-danger'>
                      Email is required
                    </Form.Text>
                  )}
                </Form.Group>

                <Form.Group controlId='password' className='mb-3'>
                  <Form.Control
                    type='password'
                    size='lg'
                    className='input-rounded border'
                    placeholder='Password'
                    minLength={6}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  {error && !password && (
                    <Form.Text className='small help-block text-danger'>
                      Password is required
                    </Form.Text>
                  )}
                </Form.Group>

                <Form.Group controlId='phoneNumber' className='mb-3'>
                  <Form.Control
                    type='number'
                    size='lg'
                    className='input-rounded border'
                    placeholder='Phone Number'
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                  {error && !phoneNumber && (
                    <Form.Text className='small help-block text-danger'>
                      Phone Number is required
                    </Form.Text>
                  )}
                </Form.Group>

                <button
                  className='btn button-primary btn-rounded btn-block btn-lg'
                  onClick={registerUser}
                  type='submit'
                >
                  Register
                </button>
              </Form>
            </div>
          </div>
        </div>
      </div>

      {/* <Notifications options={{ zIndex: 1031 }} /> */}
    </div>
  );
}

export default RegisterUser;
